import { Box } from '@mantine/core';

import { useGetColor } from 'hooks';

import type { IconPropsType } from './types';

export const WhatsNewIcon = ({
  color,
  size = 24,
  sx,
  ...props
}: IconPropsType) => {
  const iconColor = useGetColor(color);

  return (
    <Box
      component="svg"
      sx={sx}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.2071 7.78948H16.2147M4 20L8.21053 15.7895M9.05263 20L10.7368 18.3158M4 14.9474L5.68421 13.2632M11.8327 7.35957L13.0837 6.10857C14.4923 4.69996 16.3364 4.11568 18.2881 4.02021C19.0472 3.98307 19.4268 3.9645 19.7311 4.26887C20.0355 4.57323 20.0169 4.95279 19.9798 5.71191C19.8843 7.66358 19.3 9.50772 17.8915 10.9163L16.6404 12.1673C15.6102 13.1976 15.3173 13.4905 15.5336 14.608C15.747 15.4616 15.9536 16.2883 15.3329 16.909C14.58 17.6619 13.8931 17.6619 13.1402 16.909L7.09101 10.8598C6.3381 10.1068 6.33807 9.42004 7.09101 8.66711C7.71172 8.04639 8.53835 8.25301 9.39197 8.46644C10.5095 8.68272 10.8024 8.3898 11.8327 7.35957Z"
          stroke={iconColor}
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
      </svg>
    </Box>
  );
};
